import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { EventContext, UserContext, TimeContext, UserType } from "context";
import { Postcampaign } from "./Postcampaign";
import { AdminControls, RingSpinner } from "Components";
import { Registration } from "./Registration";
import { PostRegistration } from "./PostRegistration";
import { Precampaign } from "./Precampaign";

export const Root = () => {
  const { event } = useContext(EventContext);
  const { time } = useContext(TimeContext);
  const { user, userType } = useContext(UserContext);
  const history = useHistory();
  const [adminView, setAdminView] = useState("");

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const viewHistory = urlParams.get("view");

  useEffect(() => {
    if (userType === UserType.ADMIN && !adminView) {
      setAdminView(viewHistory ? viewHistory : "precampaign");
      !viewHistory && history.push(`?view=precampaign`);
    }
    // eslint-disable-next-line
  }, [userType]);

  if (!user) return <RingSpinner />;

  const adminViews = [
    "precampaign",
    "registration",
    "postRegistration",
    "postcampaign",
  ];

  const getAdminView = () => {
    switch (viewHistory || adminView) {
      case "precampaign":
        return <Precampaign />;
      case "registration":
        return <Registration />;
      case "postRegistration":
        return <PostRegistration />;
      case "postcampaign":
        return <Postcampaign />;
      default:
        return null;
    }
  };

  if (userType === UserType.ADMIN) {
    return (
      <>
        <AdminControls
          views={adminViews}
          selectedView={adminView}
          setAdminView={setAdminView}
        />
        {getAdminView()}
      </>
    );
  }

  if (event.campaignStart > time) return <Precampaign />;

  if (userType === UserType.REGISTERED) {
    // user is registered
    return <PostRegistration />;
  }

  if (event.campaignEnd < time) return <Postcampaign />;
  return <Registration />;
};
